import { Button } from '../ui/button';
import { Link } from '@tanstack/react-router';
import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';

const CallToAction = () => {
  return (
    <section className="w-full py-12 md:py-24 lg:py-32">
      <div className="container mx-auto max-w-7xl px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg border bg-background px-6 py-16 shadow-lg md:px-12 md:py-20">
          {/* Background Pattern */}
          <div className="absolute inset-0 opacity-5">
            <div className="absolute inset-0 bg-[linear-gradient(to_right,#4f4f4f2e_1px,transparent_1px),linear-gradient(to_bottom,#4f4f4f2e_1px,transparent_1px)] bg-[size:14px_24px]" />
          </div>

          <div className="relative">
            <div className="mx-auto max-w-2xl text-center">
              <motion.h2 
                className={cn(
                  "text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl",
                  "bg-gradient-to-r from-foreground to-foreground/80 bg-clip-text text-transparent"
                )}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5 }}
              >
                The easiest way to ship an idea.
              </motion.h2>
              <motion.p 
                className="mx-auto mt-6 max-w-xl text-lg leading-8 text-muted-foreground"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.1 }}
              >
                Join thousands of developers who are building data apps faster than ever before. Start your journey today.
              </motion.p>
              <motion.div 
                className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: 0.2 }}
              >
                <Button
                  size="lg"
                  className="w-full sm:w-auto"
                  asChild
                >
                  <Link to="/sign-up" target="_blank" rel="noopener noreferrer">
                    Get Started Free
                  </Link>
                </Button>
                <Button
                  variant="outline"
                  size="lg"
                  className="w-full sm:w-auto"
                  asChild
                >
                  <Link to="https://docs.preswald.com" target="_blank" rel="noopener noreferrer">
                    View Documentation
                  </Link>
                </Button>
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
